import app from "@songfinch/customer/app";

export default function onPageLoaded<T>(callback: T) {
    if (app?.config?.globalProperties?.$bus && callback) {
        app.config.globalProperties.$bus.on("pageLoaded", callback);
    }
}
